import React, { useState } from 'react';
import { Card } from '@material-ui/core';
import { makeStyles, useTheme } from '@material-ui/core/styles';
// import CircularProgress from "@material-ui/core/CircularProgress";
import { ListViewSkeleton } from 'common/ui/skeleton-ui';
import { ListItemList } from 'modules3/components';
import SectionTab from 'constants/SectionTab';
import { ShowMore } from 'modules2/components';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import container from './SearchCard.container';

const useStyles = makeStyles((theme) => ({
  root: {
    minWidth: 345,
    background: theme.palette.paperColor,
    color: theme.palette.textColor
  },
  listContainer: {
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'space-around',
    marginTop: 10,
    marginBottom: 10
  },
  empty: {
    fontFamily: theme.typography.fontFamily,
    paddingBottom: theme.spacing(1)
  },
  label: {
    color: theme.palette.darkGray,
    fontFamily: 'Arial',
    '&$focusedLabel': {
      color: theme.palette.darkGray
    },
    '&$erroredLabel': {
      color: '#f44336'
    }
  },
  focusedLabel: {},
  erroredLabel: {},
  inputBase: {
    color: theme.palette.alternateTextColor,
    fontFamily: 'Arial'
  },
  underline: {
    '&$error:after': {
      borderBottomColor: '#f44336'
    },
    '&:after': {
      borderBottom: `2px solid rgb(255, 0, 102)`
    }
  },
  error: {},
  description: {
    position: 'relative',
    marginBottom: 20
  },
  emptytext: {
    textAlign: 'center',
    width: '100%',
    position: 'relative',
    paddingBottom: theme.spacing(1),
    fontFamily: theme.typography.fontFamily,
    textTransform: 'capitalize'
  }
}));

const SearchCard = (props) => {
  const classes = useStyles();
  const {
    searchPodcastState: { loading, query, results },
    userHistoryPodcastState: { heartedPodcastIds },
    onSetCurrentTab,
    onViewPodCastStart,
    onFetchPodCastEpisode,
    // onFetchApplePodcastEpisode,
    // onFetchListenNotesPodcastEpisode,
    onFavouritePodcast,
    onRemoveFavoritePodcast,
    onSetCurrentViewdPodPlaylist,
    onShowSnackbarNotification
  } = props;
  const theme = useTheme();
  const matchesSM = useMediaQuery(theme.breakpoints.up('xs'));

  const [moreValue, setMoreValue] = useState(matchesSM ? 6 : 6);
  const nextItem = () => setMoreValue(moreValue + 6);

  const onListItemClick = (tab, uuid) => {
    onSetCurrentTab(tab);
    onViewPodCastStart(uuid);
    onFetchPodCastEpisode(uuid);
    onSetCurrentViewdPodPlaylist(uuid);
    /*const id = uuid.toString();
        if (id.length < 15 && id.startsWith('p')) {
            onFetchPodCastEpisode(uuid);
        } else if (id.length <= 15) {
            onFetchApplePodcastEpisode(uuid);
        } else {
            onFetchListenNotesPodcastEpisode(uuid);
        }*/
  };

  const onFavouriteClick = (id) => {
    const index = heartedPodcastIds.indexOf(id);
    if (index === -1) {
      onShowSnackbarNotification(`Podcast Hearted ❤️`);
      onFavouritePodcast(id);
    } else {
      onShowSnackbarNotification(`Podcast Un-hearted 😢`);
      onRemoveFavoritePodcast(id);
    }
  };

  const displayList = (loading) => {
    if (loading) {
      return [...Array(6)].map((_, idx) => {
        return <ListViewSkeleton key={idx} />;
      });
    }

    return (
      results.length > 0 ?
      results.map((value, index) => {
        return (
          <ListItemList
            key={value.id ?? value.trackId}
            sectionTab={SectionTab.PodCastDetail}
            podcastid={value.id ?? value.trackId}
            image={value.image ?? value.artworkUrl600 ?? 'null'}
            title={value.title ?? value.trackName}
            subtitle={value.description ?? value.trackName}
            data={value}
            onListItemClick={onListItemClick}
            onFavouriteClick={onFavouriteClick}
          />
        );
      }) : (
        <div className={classes.emptytext}>
        {query} podcast not found.
      </div>
      )
    );
  };

  return (
    <Card className={classes.root}>
      {/*{loading && (
                <div className={classes.description}>
                    <CircularProgress color="primary" />
                </div>
            )}*/}
      <div className={classes.listContainer}>{displayList(loading)}</div>
      {/* <ShowMore nextRadioList={nextItem}/> */}
    </Card>
  );
};

export default container(SearchCard);
